import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { AccountContentCalendar } from '../../containers/account/AccountContentCalendar';

export const AdminAccountContentCalendarPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<AccountContentCalendar />
		</AdminDashboardPageLayout>
	);
};
